module.exports = __webpack_public_path__ + "img/ktptoutiao.1b53ea11.jpg";